var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.75C0 0.551088 0.0790176 0.360322 0.21967 0.21967C0.360322 0.0790176 0.551088 0 0.75 0L5.25 0C5.44891 0 5.63968 0.0790176 5.78033 0.21967C5.92098 0.360322 6 0.551088 6 0.75C6 0.948912 5.92098 1.13968 5.78033 1.28033C5.63968 1.42098 5.44891 1.5 5.25 1.5H1.5V5.25C1.5 5.44891 1.42098 5.63968 1.28033 5.78033C1.13968 5.92098 0.948912 6 0.75 6C0.551088 6 0.360322 5.92098 0.21967 5.78033C0.0790176 5.63968 0 5.44891 0 5.25V0.75ZM18 0.75C18 0.551088 18.079 0.360322 18.2197 0.21967C18.3603 0.0790176 18.5511 0 18.75 0L23.25 0C23.4489 0 23.6397 0.0790176 23.7803 0.21967C23.921 0.360322 24 0.551088 24 0.75V5.25C24 5.44891 23.921 5.63968 23.7803 5.78033C23.6397 5.92098 23.4489 6 23.25 6C23.0511 6 22.8603 5.92098 22.7197 5.78033C22.579 5.63968 22.5 5.44891 22.5 5.25V1.5H18.75C18.5511 1.5 18.3603 1.42098 18.2197 1.28033C18.079 1.13968 18 0.948912 18 0.75ZM0.75 18C0.948912 18 1.13968 18.079 1.28033 18.2197C1.42098 18.3603 1.5 18.5511 1.5 18.75V22.5H5.25C5.44891 22.5 5.63968 22.579 5.78033 22.7197C5.92098 22.8603 6 23.0511 6 23.25C6 23.4489 5.92098 23.6397 5.78033 23.7803C5.63968 23.921 5.44891 24 5.25 24H0.75C0.551088 24 0.360322 23.921 0.21967 23.7803C0.0790176 23.6397 0 23.4489 0 23.25V18.75C0 18.5511 0.0790176 18.3603 0.21967 18.2197C0.360322 18.079 0.551088 18 0.75 18ZM23.25 18C23.4489 18 23.6397 18.079 23.7803 18.2197C23.921 18.3603 24 18.5511 24 18.75V23.25C24 23.4489 23.921 23.6397 23.7803 23.7803C23.6397 23.921 23.4489 24 23.25 24H18.75C18.5511 24 18.3603 23.921 18.2197 23.7803C18.079 23.6397 18 23.4489 18 23.25C18 23.0511 18.079 22.8603 18.2197 22.7197C18.3603 22.579 18.5511 22.5 18.75 22.5H22.5V18.75C22.5 18.5511 22.579 18.3603 22.7197 18.2197C22.8603 18.079 23.0511 18 23.25 18ZM6 6H7.5V7.5H6V6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3H3V10.5H10.5V3ZM4.5 4.5H9V9H4.5V4.5ZM7.5 16.5H6V18H7.5V16.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.5H3V21H10.5V13.5ZM4.5 15H9V19.5H4.5V15ZM16.5 6H18V7.5H16.5V6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3H21V10.5H13.5V3ZM15 4.5V9H19.5V4.5H15ZM12 12V15H13.5V16.5H12V18H15V15H16.5V18H18V16.5H21V15H16.5V12H12ZM15 15H13.5V13.5H15V15ZM21 18H19.5V19.5H16.5V21H21V18ZM15 21V19.5H12V21H15Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13.5H21V12H18V13.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.7e6827850a2a662234833790783fcb12.svg";
export { ForwardRef as ReactComponent };